import { IO_KINDS, typeLabel, typeMeta } from "@/lib/fieldDependencyConstants";
import TypeBadge from "@/components/fielddeps/TypeBadge";

/** Iter 42 — parser-proven I/O mix: proportional bar + per-kind counts. */
export default function IoMixStrip({ io, compact = false, testid = "fd-io-mix" }) {
  if (!io) return null;
  const total = IO_KINDS.reduce((n, k) => n + (io[k] || 0), 0);
  if (!total) {
    return (
      <div className="ml-card px-4 py-3 text-xs text-[var(--ml-text-secondary)]" data-testid={testid}>
        No parser-proven field I/O yet — parse RPG source (EVAL, IF, CHAIN keys, %fields on WRITE/UPDATE) and rebuild.
      </div>
    );
  }
  return (
    <div className={compact ? "space-y-1.5" : "ml-card px-4 py-3 space-y-2"} data-testid={testid} data-total={total}>
      {!compact && (
        <div className="flex items-center justify-between gap-2">
          <div className="ml-mono text-[10px] uppercase tracking-widest text-[var(--ml-text-secondary)]">Parser-proven field I/O · {total} typed reference{total === 1 ? "" : "s"}</div>
          <div className="text-[11px] text-[var(--ml-text-secondary)]">Record-level READ/WRITE and expression operands are deliberately not typed.</div>
        </div>
      )}
      <div className="flex h-2 w-full overflow-hidden border border-[var(--ml-border)]" aria-hidden="true">
        {IO_KINDS.map((k) => (io[k] ? (
          <div key={k} style={{ width: `${(io[k] / total) * 100}%`, background: typeMeta(k).fg, opacity: k === "unknown" ? 0.35 : 0.85 }} title={`${typeLabel(k)} ${io[k]}`} />
        ) : null))}
      </div>
      <div className="flex flex-wrap gap-1.5">
        {IO_KINDS.map((k) => <TypeBadge key={k} type={k} count={io[k] || 0} testid={`${testid}-${k}`} />)}
      </div>
    </div>
  );
}
